import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import Game from './models/game';

// ========================================

ReactDOM.render(
  <Game />,
  document.getElementById('root'),
);
